import ApiService from '@/common/api.service'

export default {
    getChoiceItemData () {
        return new Promise((resolve, reject) => {
            ApiService.query('/choice-item/list').then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sendEmail (data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/mail/sendContactReqMail', data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getInformPrefectureMaster () {
        return new Promise((resolve, reject) => {
            ApiService.query('/prefecture-master/list').then(response => {
                resolve(response)
            }).catch(error => {
              reject(error)
            })
        })
    },
    editInformMember (data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/member/update', data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
